import type { ReactNode } from "react";
import { ButtonElement } from "../styles/Button.styled";
import type { DefaultButtonProps, GlobalProps } from "../types";

export const Container = ({
  settings,
  children,
  isSecondary,
}: {
  settings: DefaultButtonProps & GlobalProps;
  children: ReactNode;
  isSecondary: boolean;
}) => (
  <ButtonElement
    data-button-type={isSecondary ? "secondary" : "primary"}
    className="buttonElement tw-flex tw-w-full tw-flex-col"
    $isSecondary={isSecondary}
    {...STYLED_ATTRIBUTES({ settings })}
    data-analytics-click-event={settings.analyticsClickEvent}
  >
    {children}
  </ButtonElement>
);

const STYLED_ATTRIBUTES = ({
  settings,
}: {
  settings: DefaultButtonProps & GlobalProps;
}) => ({
  $color: settings.color,
  $background: settings.background,
  $colorHover: settings.colorHover,
  $backgroundHover: settings.backgroundHover,
  $round: settings.round,
  $fontSize: settings.fontSize,
  $horizontalAlignment: settings.horizontalAlignment,
  $borderWidth: settings.borderWidth,
  $borderColor: settings.borderColor,
  $borderColorHover: settings.borderColorHover,
  $textDirection: settings.textDirection,
  $isBold: settings.isBold,
});
